<template>
  <v-container fluid>
    <v-row class="d-flex justify-center">
      <v-col cols="12">
        <div class="d-flex justify-center">
          <v-subheader class="headline font-weight-bold ">Select Kit to place order</v-subheader>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" v-if="modules.WOW_KIT_ORDERS">
        <router-link :to="{ name: 'wowKitDashboard' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-tag-heart-outline" color="pink" cardTitle="WOW Kit">
          </clickable-card>
        </router-link>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" v-if="modules.RTO_ORDERS">
        <router-link :to="{ name: 'rtoKitOrderList' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-account" color="orange" cardTitle="Re-Order Kit">
          </clickable-card>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Utils from '@/utils'
import ClickableCard from '@/components/template/ClickableCard'

export default {
  name: 'placeOrder',
  components: { ClickableCard },
  data () {
    return {
      isAdmin: Utils.helper.checkAccessByLevel(Utils.access.level.level_2),
      modules: {
        WOW_KIT_ORDERS: this.checkModuleAccess('WOW_KIT_ORDERS'),
        RTO_ORDERS: this.checkModuleAccess('RTO_ORDERS')
      }
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  },
  created () {
    console.log(this.checkModuleAccess('RTO_ORDERS'))
  }
}
</script>
